<template>
    <div :class="{'map-container--fixed': keyboardShown}">
        <headerApp></headerApp>
        <div id="map-wrapper" class="map-wrapper" :style="{ 'height': fixHeight }" :class="{ 'with-message': messagePanelAvailable }">
            <PassengerTrip v-if="!isChofer"></PassengerTrip>
            <DriverTrip v-if="isChofer"></DriverTrip>
            <vue-maps
                :center="mapCenter"
                :zoom="zoom"
                :points="points"
                :notCenteredPoints="circulatingDrivers"
                :drawRouteData ="drawRouteData"
                v-on:zoom_changed="zoomChange"
                v-on:center_changed="centerChange"
                v-on:drag_start="dragStart"
                v-on:map_click="mapClick"
                :allowToSelectPosition="!isChofer && isRequesting"
                :selectPositionIcon="iconMap">
            </vue-maps>
            <MessagePanel v-if="messagePanelAvailable"></MessagePanel>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import PassengerTrip from '../sections/PassengerTrip.vue';
import DriverTrip from '../sections/DriverTrip.vue';
import bus from '@/services/bus-event';
import { TRIP_STATE } from '@/store/mutation-types';
import MessagePanel from '../sections/MessagePanel.vue';

/* eslint-disable import/no-webpack-loader-syntax */
let taxiIcon = require('resources/default/img/taxi.png');
let userIcon = require('resources/default/img/user.png');
let destinationIcon = require('resources/default/img/destination.png');

export default {
    name: 'home',
    data () {
        return {
            zoom: 15,
            center: null
        };
    },
    mounted () {
        this.language = this.$getLang();
    },
    computed: {
        ...mapGetters({
            'myPosition': 'geolocation/actual',
            'user': 'auth/user',
            'isChofer': 'auth/isChofer',
            'isRequesting': 'passenger/isRequesting',
            'requestPosition': 'passenger/requestPosition',
            'driverPosition': 'passenger/driverPosition',
            'passengerPosition': 'driver/passengerPosition',
            'passengerOffered': 'driver/passengerOffered',
            'driverIsAvailable': 'driver/isAvailable',
            'keyboardShown': 'device/keyboardShown',
            'availableDrivers': 'passenger/availableDrivers',
            'driverTrip': 'driver/actualTrip',
            'passengerTrip': 'passenger/actualTrip',
            'settings': 'company/config',
            'currentTrip': 'auth/currentTrip'
        }),
        drawRouteData () {
            if (this.settings.modulo_sugerir_ruta_origen_destino) {
                if (this.isChofer) {
                    if ((this.driverTrip && this.driverTrip.frontState !== TRIP_STATE.RIDEUP && this.driverTrip.frontState !== TRIP_STATE.ARRIVED_TO_DESTINATION && this.passengerPosition) || (!this.driverTrip && this.passengerOffered)) {
                        return { // show route to origin
                            origin: this.myPosition,
                            destination: this.passengerPosition ? this.passengerPosition : this.passengerOffered
                        };
                    } else if (this.settings.modulo_destino_viaje) {
                        if (this.driverTrip && this.driverTrip.dest_lat && this.driverTrip.dest_lng) {
                            return {
                                origin: this.myPosition,
                                destination: {
                                    lat: this.driverTrip.dest_lat,
                                    lng: this.driverTrip.dest_lng
                                }
                            };
                        } else {
                            return null;
                        }
                    }
                } else if (this.settings.modulo_destino_viaje && this.passengerTrip && (this.passengerTrip.frontState === TRIP_STATE.RIDEUP || this.passengerTrip.frontState === TRIP_STATE.ARRIVED_TO_DESTINATION)) {
                    return {
                        origin: this.myPosition,
                        destination: {
                            lat: this.passengerTrip.dest_lat,
                            lng: this.passengerTrip.dest_lng
                        }
                    };
                } else {
                    return null;
                }
            }
        },
        points () {
            let me = {
                location: this.myPosition,
                icon: this.isChofer ? taxiIcon : userIcon
            };
            let icons = [me];
            if (!this.isChofer) {
                icons = [];
                if (this.passengerTrip) {
                    let requestPosition = {
                        location: this.requestPosition,
                        icon: userIcon
                    };
                    if (this.passengerTrip.frontState === TRIP_STATE.RIDEUP || this.passengerTrip.frontState === TRIP_STATE.ARRIVED_TO_DESTINATION) {
                        me.icon = taxiIcon;
                        icons.push(me);
                    } else if (this.driverPosition) {
                        let driverPosition = {
                            location: this.driverPosition,
                            icon: taxiIcon
                        };
                        icons.push(driverPosition);
                        icons.push(requestPosition);
                    }
                }
            } else {
                if (!this.driverIsAvailable) {
                    return [];
                }
                if (this.passengerPosition && this.driverTrip && this.driverTrip.frontState !== TRIP_STATE.RIDEUP && this.driverTrip.frontState !== TRIP_STATE.ARRIVED_TO_DESTINATION) {
                    let passengerPosition = {
                        location: this.passengerPosition,
                        icon: userIcon
                    };
                    icons.push(passengerPosition);
                } else if (this.passengerOffered && !this.driverTrip) {
                    let passengerOffered = {
                        location: this.passengerOffered,
                        icon: userIcon
                    };
                    icons.push(passengerOffered);
                }
            }
            if (this.settings.modulo_destino_viaje) {
                let who = this.isChofer ? 'driverTrip' : 'passengerTrip';
                if (this[who] && this[who].dest_lat && this[who].dest_lng && (this[who].frontState === TRIP_STATE.RIDEUP || this[who].frontState === TRIP_STATE.ARRIVED_TO_DESTINATION)) {
                    let destinationPosition = {
                        location: {
                            lat: this[who].dest_lat,
                            lng: this[who].dest_lng
                        },
                        icon: destinationIcon
                    };
                    icons.push(destinationPosition);
                };
            }
            return icons;
        },
        iconMap () {
            return userIcon;
        },
        mapCenter () { // Esto queda a handlear, hay que ver si handleamos aca o en Maps.Vue
            let position;
            if (this.center && !this.isChofer && !this.isRequesting) { //
                return this.center;
            }
            if (this.requestPosition) {
                return this.requestPosition;
            }
            if (this.myPosition) {
                position = this.myPosition;
            } else {
                if (this.user && this.user.zona) {
                    position = this.user.zona;
                }
            }
            return position;
        },
        fixHeight () {
            if (this.keyboardShown) {
                let elem = document.getElementById('map-wrapper');
                return elem ? (elem.clientHeight + 'px') : '';
            } else {
                return '';
            }
        },
        circulatingDrivers () {
            let icons = [];
            if (!this.isChofer) {
                let keys = Object.keys(this.availableDrivers);
                if (keys && keys.length) {
                    for (let id in this.availableDrivers) {
                        const driver = this.availableDrivers[id];
                        if (driver.actual) {
                            let driverAvailable = {
                                location: {
                                    lat: driver.actual.lat,
                                    lng: driver.actual.lng
                                },
                                icon: taxiIcon
                            };
                            icons.push(driverAvailable);
                        }
                    }
                }
            }
            return icons;
        },
        messagePanelAvailable () {
            return this.settings && this.settings.modulo_mensajes && this.currentTrip && this.currentTrip.frontState !== TRIP_STATE.PENDING;
        }
    },
    methods: {
        zoomChange (value) {
            this.zoom = value;
        },
        centerChange (center) {
            this.center = center;
        },
        dragStart (event) {
            bus.emit('drag_start', event);
        },
        mapClick () {
            bus.emit('map_click', event);
        }
    },
    components: {
        PassengerTrip,
        DriverTrip,
        MessagePanel
    }
};
</script>

<style scoped>
    .map-wrapper {
        height: calc(100vh - var(--header-height) - var(--ios-pad));
        position: relative;
    }
    /* MessagePanel is position:absolute at bottom — do not subtract its height here */
    .map-wrapper.with-message {
        height: calc(100vh - var(--header-height) - var(--ios-pad));
        position: relative;
    }
    .map-container--fixed {
        overflow: hidden;
        height: 100vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue